module.exports = __webpack_public_path__ + "img/logo.ba422290.svg";